import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  CitizensService,
  MunicipalEntitiesService,
  RolesService,
  SalesPointsService,
  UsersService,
} from '@prodcard/core'
import UsersTool from './tools/UsersTool.vue'
import CitizensTool from './tools/CitizensTool.vue'
import SalesPointsTool from './tools/SalesPointsTool.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TestingPage',
  props: {
    usersService: {},
    rolesService: {},
    citizenService: {},
    municipalEntitiesService: {},
    salesPointsService: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UsersTool, {
      "users-service": _ctx.usersService,
      "roles-service": _ctx.rolesService
    }, null, 8, ["users-service", "roles-service"]),
    _createVNode(CitizensTool, {
      "citizen-service": _ctx.citizenService,
      "municipal-entities-service": _ctx.municipalEntitiesService
    }, null, 8, ["citizen-service", "municipal-entities-service"]),
    _createVNode(SalesPointsTool, {
      "municipal-entities-service": _ctx.municipalEntitiesService,
      "sales-points-service": _ctx.salesPointsService
    }, null, 8, ["municipal-entities-service", "sales-points-service"])
  ], 64))
}
}

})